(function () {
  'use strict';
  // July 2026: 'load more' for collection pages — appends the next page's products
  // and keeps working with the filter (reads the current next URL each time).
  function gridEl() { return document.getElementById('product-grid'); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.collection-load-more') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    var url = btn.getAttribute('data-next-url');
    if (!url) return;
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'טוען…';

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        var g = gridEl();
        if (newGrid && g) {
          var kids = newGrid.children;
          var frag = document.createDocumentFragment();
          for (var i = 0; i < kids.length; i++) {
            if (kids[i].tagName === 'LI') frag.appendChild(document.importNode(kids[i], true));
          }
          g.appendChild(frag);
        }
        var newBtn = doc.querySelector('.collection-load-more');
        if (newBtn && newBtn.getAttribute('data-next-url')) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
        } else {
          var wrap = btn.closest('.collection-load-more-wrap') || btn;
          if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        }
        try { document.dispatchEvent(new CustomEvent('products:loaded')); } catch (err) {}
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
      });
  });
  function updateViewedCount(){var g=gridEl();if(!g)return;var n=g.querySelectorAll(':scope > li').length;var s=document.querySelectorAll('.collection-load-more-count__shown');for(var i=0;i<s.length;i++){s[i].textContent=n;}}
  document.addEventListener('products:loaded', updateViewedCount);
  if (document.readyState!=='loading'){ updateViewedCount(); } else { document.addEventListener('DOMContentLoaded', updateViewedCount); }
})();
